// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"163":"map","372":"client-only-ui"}[chunkId] + "." + {"163":"20328fa4f96b0b5e3872","372":"0a84bcdf3488138c4ee1"}[chunkId] + ".bundle.js";
};